<template>
  <el-popover :placement="placement" width="200" trigger="manual" v-model="visable" popper-class="custom-my-popper">
    <div>
      <div class="tip-text">
        {{title}}
      </div>
      <div class="btn-main">
        <span @click="clickBtn">
          知道了
        </span>
      </div>
    </div>
    <div slot="reference">
      <slot name="reference"></slot>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'FunctionGuidance',
  props: {
    title: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'left'
    },
    skillKey: {//功能key
      type: String,
      default: ''
    },
    deadline: {//截止日期
      type: String,
      default: '2025-08-15'
    }
  },
  data() {
    return {
      visable: false,
    }
  },
  methods: {
    clickBtn() {
      // 区分环境
      let env = '-' + process.env.VUE_APP_MODE
      this.$store.commit('setSkillKeys', this.$props.skillKey + env)
      this.visable = false
    },
    ifShowToKey() {
      // 获取当前日期的 YYYY-MM-DD 格式
      const now = new Date();
      const currentDateStr = now.toISOString().split('T')[0];
      const isBeforeTargetDate = currentDateStr < this.$props.deadline;
      if (!isBeforeTargetDate) {
        this.visable = false
        return false
      }
      let skillKeys = this.$store.state.skillKeys
      let env = '-' + process.env.VUE_APP_MODE
      if (skillKeys.includes(this.$props.skillKey + env)) {
        this.visable = false
      } else {
        this.visable = true
      }
    }
  },
  watch: {
    skillKey: {
      handler(value) {
        console.log('skillKey handler', value)
        if (value) {
          setTimeout(() => {
            this.ifShowToKey()
          }, 500);
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.custom-my-popper {
  background-color: #0058FF;
  border: 1px solid #0058FF !important;
  .popper__arrow {
    border-left-color: #0058FF !important;
    &::after {
      border-left-color: #0058FF !important;
      border-right-color: #0058FF !important;
    }
  }
  .tip-text {
    font-size: Translate(14px);
    color: #ffffff;
    font-weight: 500;
  }
  .btn-main {
    display: flex;
    justify-content: flex-end;
    span {
      width: Translate(66px);
      height: Translate(28px);
      border-radius: Translate(4px);
      background: #ffffff;
      color: #0058FF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>